const get = require('lodash/get');

module.exports = function InitPendo(externalData) {
    if (!GlobalConfig.MhConnectPendoApiKey) {
        console.debug('Pendo initialization skipped: missing API key');
        return;
    }

    const xOrgId = get(externalData, 'custom_org_xid', '');
    const xPersonId = get(externalData, 'custom_person_xid', '');
    if (!xOrgId || !xPersonId) {
        console.debug('Pendo initialization skipped: invalid/missing xOrgId or xPersonId');
        return;
    }

    console.debug('Pendo initialization started', xOrgId, xPersonId);
    let intervalCounter = 0;
    const intervalMax = 5;
    function _initPendo() {
        intervalCounter += 1;
        if (intervalCounter > intervalMax) {
            console.error('Pendo initialization failed after', intervalMax, 'attempts');
            clearInterval(loadInterval);
            return;
        }

        if (!window['pendo']) {
            console.warn('Pendo not loaded yet');
            return;
        }

        const pendoParams = {
            visitor: {
                id: xPersonId,
            },
            account: {
                id: xOrgId,
            }
        };
        console.debug('Initializing Pendo with:', pendoParams)
        window['pendo'].initialize(pendoParams);
        window['pendo'].validateInstall(); // delete me
        window['pendo'].validateEnvironment(); // delete me
        clearInterval(loadInterval);
    }

    const loadInterval = setInterval(function() { _initPendo(); }, 1000);
}